defineDs('DanskeSpil/Domain/AvalonComponents/Scripts/ReadMoreSpot', [
  'Shared/Framework/Mithril/Scripts/Helpers/DOMUtils',
], function (DOMUtils) {

  var readMore = function () {
    var $readMoreSpots = document.querySelectorAll('.js-read-more-spot');

    $readMoreSpots.forEach(($spot) => {
      $spot.querySelector('.js-read-more-cta')?.addEventListener('click', () => {
        $spot.classList.toggle('is-open');
        const buttonText =  $spot.classList.contains('is-open') ? 'Skjul' : 'Læs mere';
        $spot.querySelector('.js-read-more-text').textContent = buttonText;
      });
    });
  };
  DOMUtils.ready(function () {
    readMore();

  });
});











